const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-order-lookup'] = {
        c: () => require('partner/modules/dobbies-order-lookup/dobbies-order-lookup.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-order-lookup',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-order-lookup'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-order-lookup|dobbies-order-lookup'] = {
                c: () => require('partner/modules/dobbies-order-lookup/dobbies-order-lookup.view.tsx'),
                cn: '__local__-__local__-dobbies-order-lookup'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };